// extracted by mini-css-extract-plugin
module.exports = {"Avatar":"avatar_Avatar__YCT1p","Placeholder":"avatar_Placeholder__Nfc9Q"};